import { Page } from "../../components/page";
import { gql } from '@apollo/client';
import { useSubscription } from '@apollo/client/react';
import { Text } from "@fluentui/react";

const VEHICLES_SUBSCRIPTION = gql`
    subscription { 
        onVehiclePosition {
            positions {
            lineNumber
            }
        }
    }
`;

export const VehicleMap: React.FunctionComponent<{}> = () => {
    // TODO: add types
    const { data, loading } = useSubscription<any>(VEHICLES_SUBSCRIPTION, { variables: {  } });

    return (
        <Page title="Map">
            <Text>Under construction. Please check back later.</Text>
            {!loading && data.commentAdded.content}
        </Page>
    );
};

export default VehicleMap;